import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.element.addEventListener('click', () => {
      let _self = this;
      this.element.classList.toggle('disabled', true);
      this.element.insertAdjacentHTML('beforeend', '<span class="loading d-inline-block loading-on-click-triggered" style="width: 10px;"></span>');
      setTimeout(() => _self.element.disabled = true, 50)
    });
  }
};

document.addEventListener("turbo:load", () => {
  document.querySelectorAll('.loading-on-click-triggered').forEach(($el) => {
    $el.remove();
    this.element.removeAttribute('disabled');
    $el.classList.toggle('disabled', false);
  });
});